export default function Completed() {
  return (
    <div>
      <h2>Registration Complete</h2>

      <p>Your organization has been successfully created in CloudGenomics.</p>

      <p>
        A CloudGenomics staff member will now review your registration.
        You will receive an approval email once your account is activated
        and ready for use.
      </p>

      <p>Thank you for choosing CloudGenomics.</p>
    </div>
  );
}